import { ShieldCrossOutlineIcon } from './ShieldCrossOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 6C722CF2-67CA-4CEC-9197-56C4F99D2866
 * name shield-cross-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-cross-outline.svg
 * tags
 * - Gaming / RPG 
 * - Religion 
 */
export const ShieldTemplarOutlineIcon = ShieldCrossOutlineIcon;
export default ShieldTemplarOutlineIcon